import {IComponentController, IComponentOptions} from "angular";
import './user-subscription-list.component.scss';

export class UserSubscriptionListComponent implements IComponentController {

    public static instance: IComponentOptions = {
        controller: [UserSubscriptionListComponent],
        template: require('./user-subscription-list.component.html'),
        bindings: {
            user: '<'
        }
    };



    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        console.log(onChangesObj['user']);
    }



}